/**
 * Constant File for card Variations in Modal search component
 * card and tag styles, tag label, card section title, card section show more link
 */
const searchCardConstants = {
  tagLabels: {
    default: 'Resources',
    apis: 'API',
    faqs: 'FAQ',
    solutions: 'Solution',
  },
  cardVariationClass: {
    default: 'resource',
    apis: 'api',
    faqs: 'faq',
    solutions: 'case-study',
  },
  categorySectionTitle: {
    default: 'Resources',
    apis: 'APIs',
    faqs: 'Support',
    solutions: 'Solutions',
  },
  showMoreLink: {
    default: '/apis/docs-home',
    apis: '/apis/docs-home',
    faqs: '/faqs',
    solutions: '/solutions',
  },
};

export default searchCardConstants;
